import axios from "axios"
import store from "@/store"
import { getToken } from "./auth"

const service = axios.create({
    timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        if (store.getters.token) {
            if (config.headers) {
                config.headers['Authorization'] = 'bearer ' + getToken()
            }
        }

        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 请求返回拦截器
service.interceptors.response.use(
    response => {
        const resp = response.data
        if (resp.code === 0) {
            return resp
        } else {
            alert(resp.message || 'error')
            return Promise.reject(new Error(resp.message || '错误'))
        }
    },
    error => {
        return Promise.reject(error)
    }
)

export default service